<template>
  <b-row>
  <b-col>
    <b-row>
      <b-col>
        <div
          v-if="error"
          class="alert alert-dismissible alert-danger">{{ error }}</div>
        <div
          v-if="deletedItem"
          class="alert alert-dismissible alert-success">{{ deletedItem.host }}.{{ deletedItem.port }} {{$t('notifications.deleted')}}</div>
      </b-col>
    </b-row>
<!--    <b-row>-->
<!--      <b-col>-->
<!--        <h5>{{$t('views.server.list.title')}}</h5>-->
<!--      </b-col>-->
<!--    </b-row>-->
    <b-row>
      <b-col>
        <b-row>
          <b-col class="text-right">
            <router-link
              :to="{ name: 'ServerCreate' }"
              class="btn btn-primary">{{$t('buttons.create')}}</router-link>
          </b-col>
        </b-row>
        <b-card>
          <template v-if="isLoading">
            <Loader></Loader>
          </template>
          <template v-else>
            <div v-if="items.length > 0">
              <table class="table table-sm table-striped table-hover">
                <thead>
                <tr>
                  <th>{{$t('views.application.list.server')}}</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr  v-for="item in items"
                     :key="item['@id']">
                  <td>
                    <b-row>
                      <b-col>
                        <p>
                          <router-link
                            v-if="item"
                            :to="{name: 'ServerUpdate', params: { id: item['@id'] }}">
                          </router-link>
                          {{item.title}} - {{item.host}}:{{item.port}}
                        </p>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row >
                      <b-col>
                        <router-link
                          :to="{name: 'ServerUpdate', params: { id: item['@id'] }}" class="float-right">
                          <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                        </router-link>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              {{$t('notifications.noData')}}
            </div>
            <div v-if="view">
              <pagination
                :view="view"
                @getPage="getPage($event)"
              ></pagination>
            </div>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </b-col>
</b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Loader,
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'server/del/deleted',
    error: 'server/list/error',
    items: 'server/list/items',
    isLoading: 'server/list/isLoading',
    view: 'server/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'server/list/default'
  })
}
</script>
